import { idCardImg$ } from "../services/subjects";
import { map, tap, switchMap, filter } from "rxjs/operators";
import { of, combineLatest, firstValueFrom } from "rxjs";
import memberCardService from "../services/memberCardService";
import documentService from "../services/documentService";
import { enrolledOnly } from "utils/enrolledOnly";
import { useNotifyError } from "./useNotifyError";
import { useQuery } from "@tanstack/react-query";

export const useCardData = () => {
  const query = useQuery({
    queryKey: ["card"],
    queryFn: () => {
      const observable = memberCardService.get$.pipe(
        filter((response) => !!response.response),
        map((response) => response.response.results),
        switchMap((idCards) =>
          combineLatest([
            of([idCards[0].front_doc_id, idCards[0].back_doc_id]),
            documentService.getImageById$(idCards[0].front_doc_id),
            documentService.getImageById$(idCards[0].back_doc_id),
          ])
        ),
        map(([docIds, front, back]) => ({ docIds, front, back })),
        tap((idCardImg) => idCardImg$.next(idCardImg))
      );
      const enrolledOnlyObservable$ = enrolledOnly(idCardImg$).pipe(
        switchMap((idCardImg) =>
          idCardImg === null ? observable : of(idCardImg)
        ),
        filter((idCardImg) => !!idCardImg)
      );

      return firstValueFrom(enrolledOnlyObservable$) as Promise<{
        docIds: string[];
        front: string;
        back: string;
      }>;
    },
  });

  useNotifyError(
    query.error,
    "An error occurred while loading your ID Card. Please try again later."
  );
  return query;
};
